import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({
  items,
  defaultOpen = 0,
}: {
  items: FaqItem[];
  defaultOpen?: number;
}) {
  const [openIndexes, setOpenIndexes] = useState<number[]>(defaultOpen >= 0 ? [defaultOpen] : []);

  const toggle = (index: number) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((item) => item !== index) : [...prev, index],
    );
  };

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndexes.includes(index);
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => toggle(index)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-start justify-between gap-4 py-5 text-left"
            >
              <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {item.q}
              </h3>
              <span
                className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                  isOpen
                    ? "border-primary-400 bg-primary-500 text-background-50"
                    : "border-background-300 text-foreground-600"
                }`}
              >
                <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
              </span>
            </button>
            {isOpen && (
              <p className="max-w-3xl pb-6 pr-8 text-sm leading-7 text-foreground-600 md:text-[15px]">
                {item.a}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}